import type { CompanySettings } from '../../../types';

function escapeHtml(value: string) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function normalizeWebsiteUrl(value: string) {
  const raw = value.trim();
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw)) return raw;
  return `https://${raw}`;
}

export function buildAutoSignatureHtml(company: CompanySettings): string {
  const companyName = company.company_name.trim() || 'HeizungPro';
  const role = company.director_role.trim() || 'Geschäftsführer';
  const responsible =
    company.responsible_persons?.map((p) => (typeof p?.name === 'string' ? p.name.trim() : '')).filter(Boolean) ||
    [];
  const addressLine1 = [company.street.trim(), company.house_number.trim()].filter(Boolean).join(' ');
  const addressLine2 = [company.postal_code.trim(), company.city.trim()].filter(Boolean).join(' ');
  const websiteText = normalizeWebsiteUrl(company.website || '');
  const contactParts: string[] = [];
  const legalParts: string[] = [];
  const lines: string[] = [];

  lines.push('<p>Mit freundlichen Grüßen</p>');
  lines.push('<p><br/></p>');
  lines.push(`<div><strong>${escapeHtml(companyName)}</strong></div>`);

  if (responsible.length > 0) {
    const people = escapeHtml(responsible.join(', '));
    lines.push(`<div>${escapeHtml(role)}: ${people}</div>`);
  }

  const addressLine = [addressLine1, addressLine2].filter(Boolean).join(', ');
  if (addressLine) lines.push(`<div>${escapeHtml(addressLine)}</div>`);

  if (company.phone.trim()) {
    contactParts.push(`Tel: ${escapeHtml(company.phone.trim())}`);
  }
  if (company.email.trim()) {
    contactParts.push(`E-Mail: ${escapeHtml(company.email.trim())}`);
  }
  if (contactParts.length > 0) lines.push(`<div>${contactParts.join(' | ')}</div>`);

  if (websiteText) {
    legalParts.push(`Web: ${escapeHtml(websiteText)}`);
  }
  if (company.vat_id.trim()) {
    legalParts.push(`USt-IdNr.: ${escapeHtml(company.vat_id.trim())}`);
  }
  if (legalParts.length > 0) lines.push(`<div>${legalParts.join(' | ')}</div>`);

  return `<div>${lines.join('')}</div>`;
}
